<section>    
    <div class="SoldBannerImage" *ngIf="truckStatus">{{ 'truck/sold' | lowercase | translate }}</div>
    <div id="inline-gallery-container" class="inline-gallery-container" (lgSlideItemLoad)="checkImageLoaded($event)">        
    </div>
</section>